export const CLEANUP_ABOUT_PAGE_STATE = 'cleanup-about-page-state';
const cleanupAboutPageState = () => ({ type: CLEANUP_ABOUT_PAGE_STATE });
export default cleanupAboutPageState;
